import { render, staticRenderFns } from "./EditSellerConfirmDialog.vue?vue&type=template&id=6fd12d1e&scoped=true&"
import script from "./EditSellerConfirmDialog.vue?vue&type=script&lang=js&"
export * from "./EditSellerConfirmDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditSellerConfirmDialog.vue?vue&type=style&index=0&id=6fd12d1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd12d1e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/buddy/kontalk/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
installComponents(component, {VBtn,VDialog,VIcon,VLayout,VSpacer})
